import { useState } from 'react';

export default function PortfolioSection() {
  const [showMessage, setShowMessage] = useState(false);

  const portfolios = [
    {
      image: 'https://static.readdy.ai/image/b90f078cf90066d31dc5715f1c64017a/776aa2b7b927b6e1336a0e8a8898130e.jpeg',
      title: '物流会社コーポレートサイト',
      description: '信頼を伝え、選ばれるBtoBサイト',
      isActive: true,
      link: 'https://rrjapan-kobe.com'
    },
    {
      image: 'https://static.readdy.ai/image/b90f078cf90066d31dc5715f1c64017a/4ead4a978e984cbf64ab1cacf6fa3778.jpeg',
      title: '高級ペット商材 ECサイト',
      description: 'ブランド価値を高める、高級ペットECサイト',
      isActive: true,
      link: 'https://tauroprolineshop.jp/'
    },
    {
      image: 'https://static.readdy.ai/image/b90f078cf90066d31dc5715f1c64017a/2885a7dd88f70b87b9d7f9b5bb3040e5.jpeg',
      title: 'リフォーム会社HP',
      description: '地域で選ばれる、問い合わせ導線設計',
      isActive: true,
      link: 'https://kstyle-kobe.com/'
    },
    {
      image: 'https://static.readdy.ai/image/b90f078cf90066d31dc5715f1c64017a/5c14c6991d656842b4edae6ab95f1a8f.jpeg',
      title: '不動産会社LP',
      description: '物件情報を自社で登録・更新できる仕組みを構築',
      isActive: true,
      link: 'https://kaila0120.com/'
    },
    {
      image: 'https://static.readdy.ai/image/b90f078cf90066d31dc5715f1c64017a/647a285835a3a31ec7e53f1a7d28b349.jpeg',
      title: 'モール系ECサイト',
      description: 'BtoB/BtoCを一体化したShopify構築',
      isActive: true,
      link: 'https://peekazoo.net/'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Medical%20clinic%20website%20design%2C%20healthcare%20professional%20site%2C%20appointment%20booking%20interface%2C%20clean%20medical%20website%20layout%2C%20trust-building%20design%2C%20patient-friendly%20interface%2C%20healthcare%20industry%20website&width=600&height=400&seq=portfolio-4&orientation=landscape',
      title: 'クリニックサイト',
      description: '患者様に安心感を提供',
      isActive: false
    }
  ];

  return (
    <section className="py-20 bg-white relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-navy mb-4">
            制作実績ギャラリー
          </h2>
          <p className="text-xl text-gray-600">
            制作会社は「実績」で決まります。
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {portfolios.map((portfolio, index) => {
            const inner = (
              <div className="relative overflow-hidden rounded-lg shadow-lg">
                <img 
                  src={portfolio.image}
                  alt={portfolio.title}
                  className={`w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300 ${!portfolio.isActive ? 'opacity-70' : ''}`}
                />
                {!portfolio.isActive && (
                  <div className="absolute inset-0 bg-navy/30 flex items-center justify-center">
                    <span className="text-white text-lg font-semibold bg-navy/50 px-4 py-2 rounded-lg">
                      準備中
                    </span>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-navy/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-4 left-4 right-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <h3 className="text-lg font-bold mb-1">{portfolio.title}</h3>
                  <p className="text-sm">{portfolio.description}</p>
                </div>
              </div>
            );

            if (portfolio.isActive && portfolio.link) {
              return (
                <a
                  key={index}
                  href={portfolio.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group cursor-pointer block"
                >
                  {inner}
                </a>
              );
            }

            return (
              <div
                key={index}
                onClick={() => {
                  setShowMessage(true);
                  setTimeout(() => setShowMessage(false), 3000);
                }}
                className="group cursor-pointer block relative"
              >
                {inner}
              </div>
            );
          })}
        </div>
      </div>

      {showMessage && (
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-navy/90 text-white px-8 py-4 rounded-lg z-50 text-center">
          <p className="text-lg font-semibold">現在準備中です</p>
          <p className="text-sm mt-1">近日公開予定です。お楽しみに！</p>
        </div>
      )}
    </section>
  );
}
